export default __webpack_public_path__ + "static/media/account-commingsoon.6b86c81f.svg";